import styled from 'styled-components';

export const BetContainer = styled.div`
  width: 100%;
  max-width: 385px;
  margin: auto;
  ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
    max-width: 100%;
    margin: auto;
  };
  background-color: ${props => props.theme.colors.betDark};
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-direction: column;
  padding-top: 3px;
  padding-bottom: 4px;
  span {
    margin-top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.colors.betLabel};
    &:last-child {
      > div:first-child {
        font-size: 0.65em;
        ${props => props.theme.mediaQueries.small_phone}{
          font-size: 0.50em;
        }
      }
    }
  }
`;

export const ImageContainer = styled.div`
  height: 20px;
  margin: 0px 5px 0px 3px;
  .impressions {
      width: 1px;
    }
  ${props => props.theme.mediaQueries.tablet_big_down}{
  margin: 0px 5px 0px 0px;
  }
    img {
      height: 100%;
      image-rendering: auto;
      image-rendering: crisp-edges;
      border-radius: 3px;
    }
`;

export const BetPoint = styled.a`
  font-family: ${props => (props.isTitleNarrowMedium ? `${props.theme.fontSets.narrowMedium}` : `${props.theme.fontSets.narrowRegular}`)};
  font-size: 11px;
  background-color: ${props => props.theme.colors.betLight};
  padding: 3px;
  margin: ${props => (props.margin)};
  min-width: 12px;
  display: flex;
  flex-direction: row;
  border-radius: ${props => (props.radius)};
  color: ${props => props.theme.colors.betLabel};
`;

export const BetRibbon = styled.div`
  padding: 0px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  font-size: 10px;
  background-color: ${props => props.theme.colors.betLight};
  margin-left: 5px;
  color: ${props => props.theme.colors.betLabel};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${props => (props.isTitleNarrowMedium ? `${props.theme.fontSets.narrowMedium}` : `${props.theme.fontSets.narrowRegular}`)};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    height: 17px;
    width: 17px;
    font-size: 8px;
  }
`;




// WEBPACK FOOTER //
// ./src/components/BetBar/styles.js